<template>
  <v-form>
    <v-container>
      <v-layout>
        <div class="decretosBoton">
          <v-menu bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small tile outline color="primary">
                <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
              </v-btn>
            </template>
            <v-card class="px-2 py-1">
              <v-card-text class="black--text body-2">
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>
                  <b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas"</b>...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días..."
                </span>
                <br />
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>Ingresar todos los “Otros bienes” que estén a nombre del declarante y/o a nombre de su cónyuge o conviviente (en el caso de bienes comunes). No se debe declarar prendas de uso personal, los muebles corrientes, electrodomésticos y otros imprescindibles en su hogar, ni objetos de colección sin valor comercial.</span>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
        <v-flex xs12 md12 class="decretos">
          <alert-extendible
            texto='<b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas"</b>...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días...'
          ></alert-extendible>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md12 class="decretos">
          <alert-extendible
            texto="Ingresar todos los “Otros bienes” que estén a nombre del declarante y/o a nombre de su cónyuge o conviviente (en el caso de bienes comunes). No se debe declarar prendas de uso personal, los muebles corrientes, electrodomésticos y otros imprescindibles en su hogar, ni objetos de colección sin valor comercial."
          ></alert-extendible>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn color="success" dark @click.stop="dialog = true">
          <v-icon>add</v-icon>&nbsp;Adicionar
        </v-btn>
      </v-layout>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-dialog v-model="dialog" scrollable :max-width="deleteMode?600:1200" persistent>
          <v-card>
            <v-toolbar dark color="primary" right>
              <v-toolbar-title>
                <h4>Otros Bienes</h4>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="cancel()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <div class="decretosBoton">
                    <v-menu bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small tile outline color="primary">
                          <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
                        </v-btn>
                      </template>
                      <v-card class="px-2 py-1">
                        <v-card-text class="black--text body-2">
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>Ingresar todos los “Otros bienes” que estén a nombre del declarante y/o a nombre de su cónyuge o conviviente (en el caso de bienes comunes). No se debe declarar prendas de uso personal, los muebles corrientes, electrodomésticos y otros imprescindibles en su hogar, ni objetos de colección sin valor comercial.</span>
                          <br />
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>
                            <b>Tipo de Adquisición:</b>
                            Especificar si el bien es Propio o si es Común de acuerdo a los artículos 178 y siguientes del Código de las Familias y del Proceso Familiar.
                            <br />
                            <b>Tipo de Bien:</b> Seleccionando uno de los tipos de bienes reflejados en la lista desplegable.
                            <br />
                            <b>Descripción, Ubicación, País:</b>
                            Describir el bien indicando cantidades y características que lo individualicen (denominación, datos del deudor, del anticresista, garantías, entidades aseguradoras, marca de ganado, etc.) y consignar la ubicación exacta del mismo.
                            <br />
                            <b>Valor del bien en Bs.(precio referencial):</b>
                            Detallar el valor referencial del bien en moneda nacional.
                            <br />
                            <b>Rentas Generadas en Bs.:</b>
                            Si el bien genera rentas, debe detallar el importe en moneda nacional de dicha renta. 
                          </span>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </div>
                  <v-flex xs12 md12 class="decretos">
                    <alert-extendible
                      v-show="!deleteMode"
                      texto="Ingresar todos los “Otros bienes” que estén a nombre del declarante y/o a nombre de su cónyuge o conviviente (en el caso de bienes comunes). No se debe declarar prendas de uso personal, los muebles corrientes, electrodomésticos y otros imprescindibles en su hogar, ni objetos de colección sin valor comercial."
                    ></alert-extendible>
                    <alert-extendible
                      v-show="!deleteMode"
                      texto="<b>Tipo de Adquisición:</b>
                      Especificar si el bien es Propio o si es Común de acuerdo a los artículos 178 y siguientes del Código de las Familias y del Proceso Familiar. <br>
                      <b>Tipo de Bien:</b> Seleccionando uno de los tipos de bienes reflejados en la lista desplegable. <br>
                      <b>Descripción, Ubicación, País:</b> Describir el bien indicando cantidades y características que lo individualicen (denominación, datos del deudor, del anticresista, garantías, entidades aseguradoras, marca de ganado, etc.) y consignar la ubicación exacta del mismo.<br>
                      <b>Valor del bien en Bs.(precio referencial):</b> Detallar el valor referencial del bien en moneda nacional.</br>
                      <b>Rentas Generadas en Bs.:</b> Si el bien genera rentas, debe detallar el importe en moneda nacional de dicha renta."
                    ></alert-extendible>
                  </v-flex>
                  <v-flex xs12>
                    <v-alert
                      :value="true"
                      type="warning"
                      v-show="deleteMode"
                      outline
                    >¿Está seguro de eliminar el otro bien siguiente?</v-alert>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-select
                      :no-data-text="$t('comun.sin_datos')"
                      v-model="tipoAdquisicion"
                      :items="itemsTipoAdquisicion"
                      item-text="tipadq_descripcion"
                      item-value="tipadq_codigo"
                      label="Tipo de Adquisición*"
                      :rules="dRules"
                      required
                      :disabled="deleteMode"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-autocomplete
                      :no-data-text="$t('comun.sin_resultados_busqueda')"
                      v-model="tipoBien"
                      :items="itemsTipoBien"
                      item-text="tipbie_descripcion"
                      item-value="tipbie_codigo"
                      label="Tipo de Bien*"
                      :rules="dRules"
                      required
                      :disabled="deleteMode"
                      clearable
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="descripcion"
                          :rules="textRules"
                          label="Descripción, Ubicación, País*"
                          required
                          v-on="on"
                          maxlength="300"
                          :disabled="deleteMode"
                        ></v-text-field>
                      </template>
                      <span>Descripción, Ubicación, País: Describir el bien indicando cantidades y características que lo individualicen (denominación, datos del deudor, del anticresista, garantías, entidades aseguradoras, marca de ganado, etc.) y consignar la ubicación exacta del mismo.</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-currency-field
                      v-model="valorBien"
                      :rules="numbersRules"
                      label="Valor del bien en Bs.(precio referencial)*"
                      required
                      :disabled="deleteMode"
                    ></v-currency-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-currency-field
                      v-model="rentasBien"
                      :rules="numbersRules"
                      label="Rentas Generadas en Bs.*"
                      required
                      :disabled="deleteMode"
                    ></v-currency-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-textarea
                          @change="observaciones = $util.sanitiza(observaciones)"
                          v-model="observaciones"
                          label="Observaciones"
                          maxlength="250"
                          :counter="250"
                          hint="Máximo 250 caracteres."
                          persistent-hint
                          :rules="$validate(['text_area'])"
                          v-on="on"
                          :disabled="deleteMode"
                          rows="1"
                          auto-grow
                        ></v-textarea>
                      </template>
                      <span>Detallar cualquier aclaración que el declarante considere pertinente, respecto a los datos de “Otros Bienes”.</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <br />
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-subheader>
                      <p class="plomo--text">Por favor llene los campos requeridos*</p>
                    </v-subheader>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="loadingButton" @click="preVerificacion()">
                  <div v-if="deleteMode === true"><v-icon>delete</v-icon>&nbsp;Eliminar</div>
                  <div v-else><v-icon>save</v-icon>&nbsp;Guardar</div>
                </v-btn>
                <v-btn color="error" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-form>
      <v-layout wrap>
        <v-flex xs12 md12>
          <v-alert
            class="tamanioBoton"
            v-show="!habilitarLista"
            :value="true"
            color="info"
            icon="info"
          >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
        </v-flex>
        <v-flex v-show="habilitarLista">
          <v-data-table
            :headers="headers"
            :items="datos"
            class="elevation-1"
            rows-per-page-text="Filas por página"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props" class="justify-center layout px-0">
              <td>{{ props.item.nro }}</td>
              <td>
                <v-tooltip top color="blue">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="editItem(props.item)" v-on="on">
                      <v-icon color="blue">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top color="red">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="deleteItem(props.item)" v-on="on">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
              <td>{{ props.item.tipadq_descripcion }}</td>
              <td>{{ props.item.tipbie_descripcion }}</td>
              <td>{{ formatPrice(props.item.bie_precio_comercial) }}</td>
              <td>{{ formatPrice(props.item.bie_rentas_generadas) }}</td>
              <td>{{ props.item.bie_descripcion_ubicacion }}</td>
              <td><text-extendible :texto='props.item.bie_observacion'></text-extendible></td>
            </template>
            <template
              v-slot:pageText="props"
            >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="repetidosModal" scrollable persistent max-width="350">
          <v-card>
            <v-card-title>
              <h4>
                <v-icon color="yellow">warning</v-icon>Advertencia
              </h4>
            </v-card-title>
            <v-card-text>Intenta agregar o actualizar información que se registró anteriormente, el registro o actualización es responsabilidad del declarante.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="tamanioBoton"
                color="primary"
                flat
                @click="repetidosModal = false, guardar()"
              ><v-icon>save</v-icon>&nbsp;Agregar de todos modos</v-btn>
              <v-btn
                class="tamanioBoton"
                color="error"
                flat
                @click="repetidosModal = false, cancel()"
              ><v-icon>cancel</v-icon>&nbsp;Descartar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-form>
</template>
<script>
import validate from '@/common/mixins/validate';
import Parametricas from '../djbrd/mixins/parametricas';
import jsonQuery from 'json-query';
export default {
  mixins: [ Parametricas, validate ],
  created () {
    if (this.$storage.get('ex') === 1 && this.itemsTipoAdquisicion.length === 0) {
      this.obtenerTipoAdquisicionParametrica().then((respuesta) => {
        this.itemsTipoAdquisicion = respuesta.datos;
      });
      this.$service.get(`subtipo_bien/${this.subTipoBien}`, {}).then(response => {
        if (response) {
          this.itemsTipoBien = response;
        }
      });
      this.obtenerBienes();
    }
  },
  data: () => ({
    loadingButton: false,
    codBien: 0,
    subTipoBien: 4, // TiposBien 4 {6,7,8,9,10,11,12,13,14}
    listaTipoBienes: 4, // TiposBien 4 {6,7,8,9,10,11,12,13,14}
    headers: [
      { text: 'Nro', sortable: false, value: 'nro' },
      { text: 'Acciones', sortable: false, value: 'acciones' },
      {
        text: 'Tipo de Adquisición',
        sortable: false,
        value: 'tipoAdquisicion'
      },
      {
        text: 'Tipo de Bien',
        sortable: false,
        value: 'tipoBien'
      },
      { text: 'Valor del Bien en Bs.', sortable: false, value: 'valorBien' },
      {
        text: 'Rentas Generadas en Bs.',
        sortable: false,
        value: 'rentasBien'
      }, //
      { text: 'Descripción', sortable: false, value: 'descripcion' }, //
      { text: 'Observaciones', sortable: false, value: 'observaciones' }
    ],
    datos: [],
    tipoAdquisicion: 0,
    rowsPerPageItems: [5, 10, 25, {'text': 'Todo', 'value': -1}],
    itemsTipoAdquisicion: [],
    tipoBien: 0,
    itemsTipoBien: [],
    descripcion: '',
    valorBien: 0,
    rentasBien: 0,
    observaciones: '',
    mask_anio: '####',
    nro: 1,
    dialog: false,
    menu1: false,
    menu2: false,
    editMode: false,
    deleteMode: false,
    dRules: [v => !!v || 'Este campo es requerido'],
    textRules: [v => !!v || 'Este campo es requerido', v => /^[a-zA-Z0-9-_/.*()"“”,.;:=#º°ñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜ$ ]+$/.test(v) || 'Carácter especial no permitido'],
    numbersRules: [v => !!v || 'Este campo es requerido y debe ser un monto en Bolivianos',
      v => v.length < 11 || 'El valor solo puede tener máximo 8 números'],
    currency_config: {
      thousands: '.',
      decimal: ',',
      prefix: 'Bs.',
      precision: 0,
      masked: false,
      allowBlank: true
    },
    valid: true,
    habilitarLista: false,
    repetidosModal: false
  }),
  methods: {
    save () {
      if (this.$refs.form.validate()) {
        let params = {
          cod_tipo_adquisicion: this.tipoAdquisicion,
          cod_tipo_bien: this.tipoBien,
          descripcion: this.descripcion,
          valor_bien: this.valorBien,
          rentas_generadas: this.rentasBien,
          observacion: this.observaciones
        };
        this.$service
        .post(`djbr_registro/otros_bienes`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.editMode = false;
              this.dialog = false;
              this.reinicializa();
              this.obtenerBienes();
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
      }
    },
    update () {
      let params = {
        cod_bien: this.codBien,
        cod_tipo_adquisicion: this.tipoAdquisicion,
        cod_tipo_bien: this.tipoBien,
        descripcion: this.descripcion,
        valor_bien: this.valorBien,
        rentas_generadas: this.rentasBien,
        observacion: this.observaciones
      };
      this.$service
        .put(`djbr_registro/otros_bienes`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerBienes();
              this.editMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    delete () {
      this.$service.delete(`djbr_registro/bienes/${this.codBien}`)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerBienes();
              this.deleteMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    obtenerBienes () {
      this.$service.get(`djbr_registro/bienes/${this.listaTipoBienes}`, {})
      .then(response => {
        if (response.length >= 1 && response[0].bie_codigo !== -1) {
          this.datos = response;
          this.nro = 0;
          for (let i = 0; i < this.datos.length; i++) {
            this.datos[i].nro = ++this.nro;
            this.habilitarLista = true;
          }
        } else {
          this.datos = [];
          this.habilitarLista = false;
        }
      });
    },
    editItem (item) {
      this.cargaData(item);
      this.editMode = true;
      this.dialog = true;
    },
    deleteItem (item) {
      this.cargaData(item);
      this.deleteMode = true;
      this.dialog = true;
      this.$refs.form.resetValidation();
    },
    cancel () {
      this.dialog = false;
      this.editMode = false;
      this.deleteMode = false;
      this.loadingButton = false;
      this.reinicializa();
    },
    preVerificacion () {
      if (this.deleteMode) {
        this.delete();
      } else {
        if (this.$refs.form.validate()) {
          this.loadingButton = true;
          if (this.valorBien < 0) {
            this.$message['warning']('Por Favor revise el valor del bien no es válido.');
            this.loadingButton = false;
          } else if (this.rentasBien < 0) {
            this.$message['warning']('Por Favor revise las rentas generadas no es válido.');
            this.loadingButton = false;
          } else {
            if (this.verificarRepetidos() && !this.deleteMode) {
              this.repetidosModal = true;
            } else {
              this.guardar();
            }
          }
        } else {
          this.$message['warning']('Por Favor revise los datos requeridos..');
        }
      }
    },
    guardar () {
      if (this.editMode) {
        this.update();
      } else {
        this.save();
      }
    },
    reinicializa () {
      this.codBien = 0;
      this.tipoAdquisicion = 0;
      this.tipoBien = 0;
      this.descripcion = null;
      this.valorBien = 0;
      this.rentasBien = 0;
      this.observaciones = '';
      this.loadingButton = false;
      this.$refs.form.resetValidation();
    },
    cargaData (item) {
      this.codBien = item.bie_codigo;
      this.tipoAdquisicion = item.tipadq_codigo;
      this.tipoBien = item.tipbie_codigo;
      this.descripcion = item.bie_descripcion_ubicacion;
      this.valorBien = item.bie_precio_comercial.replace('.00', '');
      this.rentasBien = item.bie_rentas_generadas.replace('.00', '');
      this.observaciones = item.bie_observacion;
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2).replace(',', '.').replace('.00', '');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    verificarRepetidos () {
      let data = { lista: this.datos };
      let comparing = {
        cod_tipo_adquisicion: this.tipoAdquisicion,
        cod_tipo_bien: this.tipoBien,
        descripcion: this.descripcion.toUpperCase().trim(),
        valor_bien: typeof (this.valorBien) === 'number' ? `${this.valorBien}.00` : `${this.valorBien}.00`,
        renta_generada: typeof (this.rentasGeneradas) === 'number' ? `${this.rentasBien}.00` : `${this.rentasBien}.00`,
        observacion: this.observaciones.toUpperCase().trim()
      };
      let resultQuery = jsonQuery(`lista[*tipadq_codigo=${comparing.cod_tipo_adquisicion} & 
                                   tipbie_codigo=${comparing.cod_tipo_bien} &
                                   bie_descripcion_ubicacion=${comparing.descripcion} &
                                   bie_precio_comercial=${comparing.valor_bien} &
                                   bie_rentas_generadas=${comparing.renta_generada} &
                                   bie_observacion=${comparing.observacion}]`, { data });
      if (this.editMode) {
        return resultQuery.value.length > 1;
      } else {
        return resultQuery.value.length > 0;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/bienes/bienesOtros.vue